export default {
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1920,
  navPadding: 120,
};
